export default __webpack_public_path__ + "static/media/CheckFlash.f792950c.wav";